if (!customElements.get('seasonal-catalogue')) {
  class SeasonalCatalogue extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-seasonal-row]'));
      this.abortController = new AbortController();

      this.rows.forEach((row) => this.setupRow(row));
      window.addEventListener('resize', () => this.updateRows(), {
        signal: this.abortController.signal,
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    setupRow(row) {
      const track = row.querySelector('[data-seasonal-track]');
      const previous = row.querySelector('[data-seasonal-previous]');
      const next = row.querySelector('[data-seasonal-next]');
      if (!track) return;

      const scroll = (direction) => {
        const item = track.querySelector('li');
        if (!item) return;
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const step = (item.getBoundingClientRect().width + gap) * direction;
        track.scrollBy({ left: step, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scroll(-1), { signal: this.abortController.signal });
      next?.addEventListener('click', () => scroll(1), { signal: this.abortController.signal });
      track.addEventListener('scroll', () => this.updateRow(row), {
        passive: true,
        signal: this.abortController.signal,
      });

      this.updateRow(row);
    }

    updateRows() {
      this.rows.forEach((row) => this.updateRow(row));
    }

    updateRow(row) {
      const track = row.querySelector('[data-seasonal-track]');
      const previous = row.querySelector('[data-seasonal-previous]');
      const next = row.querySelector('[data-seasonal-next]');
      if (!track) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const hasOverflow = maxScroll > 2;
      if (previous) previous.hidden = !hasOverflow || track.scrollLeft <= 2;
      if (next) next.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('seasonal-catalogue', SeasonalCatalogue);
}
